import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Container from 'react-bootstrap/Container';

import ReturnsSrv from "../../../services/returns_srv";
import ShipmentsSrv from "../../../services/shipments_srv";
import Button from "@material-ui/core/Button";

import './managelists.scss';

import "react-datepicker/dist/react-datepicker.css";
import TextField from "@material-ui/core/TextField";

import ReactTable from 'react-table-6';
import "react-table-6/react-table.css";


class ManageListsForm extends React.Component {
    shipmentsSrv;
    returnsSrv
   
    constructor(props) {
        super(props);
        
        this.state = {
            selectedModuleName: "",
            selected_Menu_Name: "",
            menuNames:[],
            validated: false,
            newProduct: {
                userProductId: "",
                productType: {
                    id: "",
                },
                location: {
                    id: "",
                }
            },
            loadingInformationList: false,
            informationDataSet: [],            
            informationDescriptionDataSet: [],
            selectedInformationDescription :   {
                informationId: "",
                informationType: "",
                informationDescription: "",
                obsolete: false,                
                shouldReview: false                    
            }
            ,
            selectedGoodInformationForRemap :   {
                informationId: "",
                informationType: "",
                informationDescription: "",
                obsolete: false,                
                shouldReview: false                    
            }
            ,
            propertyDescription: '',
            renameDescription: '',
            error: null,        
            addNotEditMode: true,
            toggleModeButtonText: 'Change to Edit Mode',
            editChoicesAvailable: false,
            userDisplay: '',            
            foundRecords: false,
            sorted: [], // sample code adapted from https://codesandbox.io/s/react-table-controlled-table-h5izv
            page: 0,
            pageSize: 10,
            expanded: {},            
            filtered: [],
            selectedExistingRow :   {
                informationId: "",
                informationType: "",
                informationDescription: "",
                obsolete: false,                
                shouldReview: false                    
            }
        };
        this.shipmentsSrv = new ShipmentsSrv(this.props.auth);     
        this.returnsSrv= new ReturnsSrv(this.props.auth);   
        
        this.getGoodDescrSelectList = this.getGoodDescrSelectList.bind(this);
        this.handleGoodDescrSelectChange = this.handleGoodDescrSelectChange.bind(this);

        this.getInformationList = this.getInformationList.bind(this);   
        this.getDescrSelectList = this.getDescrSelectList.bind(this);
        this.handleDescrSelectChange = this.handleDescrSelectChange.bind(this);
    
        this.handleProductTypeChange = this.handleProductTypeChange.bind(this);        
        this.getProductTypesSelectList = this.getProductTypesSelectList.bind(this);  
        
        this.getmoduleNamesSelectList = this.getmoduleNamesSelectList.bind(this);
        this.handlemoduleNameChange = this.handlemoduleNameChange.bind(this);

        this.get_Menu_NameSelectList = this.get_Menu_NamesSelectList.bind(this);
        this.handle_Menu_NameChange = this.handle_Menu_NameChange.bind(this);

        this.handleChangePropertyDescription = this.handleChangePropertyDescription.bind(this);
        this.handleChangeRenameDescription = this.handleChangeRenameDescription.bind(this);
        this.saveAction = this.saveAction.bind(this);
        this.acceptAction = this.acceptAction.bind(this);
        this.acceptRenameAction = this.acceptRenameAction.bind(this);
        this.reMapAction = this.reMapAction.bind(this);
        this.rejectAction = this.rejectAction.bind(this);
        this.toggleModeAction = this.toggleModeAction.bind(this)
    }

    handleGoodDescrSelectChange(event)
    {
        console.log("entered handleGoodDescrSelectChange!!!!!!");
        let index = event.target.value;
        let boxNames = this.state.informationDataSet;
        console.log(boxNames+ " with index="+ index);
        
        var found = boxNames.find(function(boxName) {
            return boxName.informationId === index;
        });
        console.log(found);

        if(found !== undefined)
        {
            this.setState({ selectedGoodInformationForRemap : found });  
            
            console.log(found +" state set."); 
        }
        else
        {
            this.setState({ selectedGoodInformationForRemap :   {
                informationId: "",
                informationType: "",
                informationDescription: "",
                obsolete: false,                
                shouldReview: false                    
            }   
            });  
            console.log("nothing state set."); 
        }
    }
    getGoodDescrSelectList()
    {
        console.log("this.getGoodDescrSelectList();")        
       // console.log(this.state.informationDataSet);        
        let shouldReviewList = [];
        
        shouldReviewList = (this.state.informationDataSet !== undefined )
                        ? this.state.informationDataSet: [];
        
            
        let selectedDescrId = (this.state.informationDataSet !== undefined 
                        && this.state.selectedGoodInformationForRemap.informationId !== undefined)
                        ?  this.state.selectedGoodInformationForRemap.informationId: '';     
            
        
        console.log("list lenght is:"+shouldReviewList.length);
        if( shouldReviewList.length > 0)
        {           
            console.log(shouldReviewList[0]);
            console.log("list has "+shouldReviewList[0].informationId);
            console.log("list has "+shouldReviewList[0].informationDescription);
            console.log("list type is "+ typeof shouldReviewList);
        }


        return (
            <Form.Control 
                as="select" 
                id="should-review-select" 
                onChange={this.handleGoodDescrSelectChange} 
                required
                value={selectedDescrId}
                title="Proposed Descriptions">
                    <option value="">-- Select --</option>
                    {                        
                        shouldReviewList.map((element, index) => (
                        <option 
                           key={element.informationId}                           
                            value={element.informationId}>
                                {element.informationDescription}
                        </option>
                    ))}                    
            </Form.Control>
        ) 
    }

    handleDescrSelectChange(event)
    {
        console.log("entered handleDescrSelectChange!!!!!!");
        let index = event.target.value;
        let boxNames = this.state.informationDescriptionDataSet;
        console.log(boxNames);
        console.log(" with index="+ index);
        
        var found = boxNames.find(function(boxName) {
            return boxName.informationId === index;
        });
        console.log(found);

        if(found !== undefined)
        {
            this.setState({ selectedInformationDescription : found,
                            renameDescription: found.informationDescription });  
            
            console.log(found.informationDescription +" setState "); 
        }
        else
        {
            this.setState({ selectedInformationDescription :   {
                informationId: "",
                informationType: "",
                informationDescription: "",
                obsolete: false,                
                shouldReview: false                    
            } ,
            renameDescription: ""        
            });  
            console.log("nothing state set."); 
        }
    }

    getDescrSelectList(dataIn)
    {   
        console.log("this.getDescrSelectList();")
        //console.log("data in  type is "+ typeof dataIn);
        console.log(this.state.informationDescriptionDataSet);
        //return this.state.informationDescriptionDataSet;
        // let shouldReviewList = (this.state.informationDescriptionDataSet == undefined )
        //                ? this.state.informationDescriptionDataSet: [];
        let shouldReviewList = [];
        
        shouldReviewList = (this.state.informationDescriptionDataSet !== undefined )
                        ? this.state.informationDescriptionDataSet: [];
        
            
        let selectedDescrId = (this.state.selectedInformationDescription !== undefined 
                        && this.state.selectedInformationDescription.informationId !== undefined)
                        ?  this.state.selectedInformationDescription.informationId: '';     
            
        
        console.log("getDescrSelectList list length is:"+shouldReviewList.length);
        if( shouldReviewList.length > 0)
        {           
            console.log(shouldReviewList[0]);
            console.log("list has "+shouldReviewList[0].informationId);
            console.log("list has "+shouldReviewList[0].informationDescription);
            console.log("list type is "+ typeof shouldReviewList);
        }


        return (
            <Form.Control 
                as="select" 
                id="should-review-select" 
                onChange={this.handleDescrSelectChange} 
                required
                value={selectedDescrId}
                title="Proposed Descriptions">
                    <option value="">-- Select --</option>
                    {                        
                        shouldReviewList.map((element, index) => (
                        <option 
                           key={element.informationId}                           
                            value={element.informationId}>
                                {element.informationDescription}
                        </option>
                    ))}                    
            </Form.Control>
        )  
    }
  
    
    handleProductTypeChange(event) {
        console.log("inside handleProductTypeChange");
        let index = event.target.value;
        let productTypes = this.props.productTypes ? this.props.productTypes: [];
        console.log(productTypes);
        console.log("index is"+index);
        //console.log(productTypes[index])
        var found = productTypes.find(function(productType) {
            return productType.id === index;
          });
        let newProduct = { ...this.state.newProduct }
        newProduct.productType = found;
        console.log(newProduct);
        this.setState({ newProduct });      
        this.getInformationList(found, this.state.selected_Menu_Name); 
    }
    getProductTypesSelectList()
    {
        let productTypes = this.props.productTypes ? this.props.productTypes: [];
        console.log(productTypes);
        if(this.state.newProduct !== undefined)
        {
            console.log("new product type="+ this.state.newProduct.productType);
            if(this.state.newProduct.productType !== undefined)
            {
                console.log(this.state.newProduct.productType.id);
            }
        }
        
        let productTypeId = (this.state.newProduct !== undefined && this.state.newProduct.productType !== undefined)?this.state.newProduct.productType.id: '';        
        
        return (
            <Form.Control 
                as="select" 
                id="product-types-select" 
                onChange={this.handleProductTypeChange} 
                required
                value={productTypeId}
                title="Article Types">
                    <option value="">-- Select Article Type --</option>
                    {productTypes.map((productType, index) => (
                        <option 
                            key={productType.id}
                            value={productType.id}>
                                {productType.name
                        }</option>
                    ))}
            </Form.Control>
        )
    }

    handlemoduleNameChange(event) {
        let index = event.target.value;
        let moduleNames = ["RMA Request", "RMA Action", "RMA Diagnosis"];
        //console.log(moduleNames+ " with index="+ index);
        //console.log(moduleNames[index])
        var found = moduleNames.find(function(moduleName) {
            return moduleName === index;
          });
        //console.log(found +"=found");        
        this.setState({ selectedModuleName : found });   
        
        
        if (found === "RMA Request")
        {
            this.setState({menuNames :
                  [
                      {id: "MainIssue", // Main Issue
                      display: "Main Issue"}
            , {id:"FaultIndication", display:"Other Observations"}]  }) // Other Observations
        }
        else if (found === "RMA Action")
        {
            this.setState({menuNames :  []  })
            
        }
        else if (found === "RMA Diagnosis")        
        {
            this.setState({menuNames :  [ {id:"FaultFound",display:"Fault"}, {id:"IssueCause", display:"Cause"}, {id:"Repair",  display:"Repair"}]  })
        }
        if (found !== undefined)
        {
            if (this.state.menuNames.length>0)
            {
                this.setState({selected_Menu_Name :  this.state.menuNames[0].id  })
            }
        }

        //console.log("menu sel is now"+this.state.selected_Menu_Name);
        this.getInformationList("", "") ; // will clear
    }

    getmoduleNamesSelectList()
    {
        console.log("getmoduleNamesSelectList()");
        let moduleNames = ["RMA Request", "RMA Action", "RMA Diagnosis"];
        let moduleNameId = this.state.selectedModuleName;
        
        console.log(moduleNames);
        return (
            <Form.Control 
                as="select" 
                id="module-select" 
                onChange={this.handlemoduleNameChange} 
                required
                value={moduleNameId}
                title="Module Names">
                    <option disabled value="">-- Select a Module --</option>
                    {moduleNames.map((moduleName, index) => (
                        <option 
                            key={moduleName}
                            value={moduleName}>
                                {moduleName // this is what is displayed
                                } 
                                </option>
                    ))}
            </Form.Control>
        )
    }
    handle_Menu_NameChange(event) {
        //console.log("entered handle_Menu_NameChange");
        let index = event.target.value;
        let menuNames = this.state.menuNames;//["MainIssue", "FaultIndication", "FaultyComponent", "Diagnosis", "CorrectiveAction"];
        console.log(menuNames+ " with index="+ index);
        console.log(menuNames[index])
        var found = menuNames.find(function(menuName) {
            return menuName.id === index;
          });
        //console.log(found +"=found");
    
        this.setState({ selected_Menu_Name : found.id });   
        //console.log("calling getInformation with new value="+this.state.selected_Menu_Name.id);
        this.getInformationList(this.state.newProduct.productType, found.id)
    }

    get_Menu_NamesSelectList()
    {
        //console.log("entered get_Menu_NamesSelectList()");
        let menuNames =this.state.menuNames; 
        if (this.state.selectedModuleName === "RMA Request")
        {
            menuNames=[{id: "MainIssue", // Main Issue
            display: "Main Issue"}
            , {id:"FaultIndication", display:"Other Observations"}];
        }
        else if (this.state.selectedModuleName === "RMA Action")
        {           
           menuNames=[ ];
        }
        else if (this.state.selectedModuleName === "RMA Diagnosis")        
        {            
            menuNames=[{id:"FaultFound", display:"Fault"}, {id:"IssueCause", display:"Cause"}, {id:"Repair",  display:"Repair"}] ;
        }
        
        let menuNameId = this.state.selected_Menu_Name;                
        //console.log(menuNames);
        return (
            <Form.Control 
                as="select" 
                id="menu-select" 
                onChange={this.handle_Menu_NameChange} 
                required
                value={menuNameId}
                title="Menu Name">
                    <option value="">-- Select Menu --</option>
                    {menuNames.map((menuName, index) => (
                        <option 
                            key={menuName.id}
                            value={menuName.id}>
                                {menuName.display // this is what is displayed
                                } 
                                </option>
                    ))}
            </Form.Control>
        )
    }
    render() {

        let moduleNameSelectList = this.getmoduleNamesSelectList();
        let menuNameSelectList = this.get_Menu_NamesSelectList();
        let productTypeSelectList = this.getProductTypesSelectList();       
        let proposedDescrSelectList = this.getDescrSelectList();
        let goodDescrSelectList = this.getGoodDescrSelectList();
        return (
            <Container className='manageList-container'>
                <Row>
                    <Col className='header' >RMA Admin</Col>
                    <Col className='header' >Actions</Col>
                </Row>
                <Row>
                    <Col >                       
                        <div className='text' >
                            <p type="text">Select Module</p>
                            {moduleNameSelectList}
                        </div>
                        <div className='text' >
                            <p type="text">Select Article Type</p>
                            {productTypeSelectList}
                        </div>  
                        <div className='text' >
                            <p type="text">Select Menu</p>
                            {menuNameSelectList}
                        </div>                       
                                             
                    </Col>
                    <Col>
                        <Row>
                            <Button                                                            
                                className="update-button show"
                                variant="contained"
                                disabled={this.state.loadingProductTypes }
                                onClick={ this.toggleModeAction  }
                                >{this.state.toggleModeButtonText}
                           </Button>                            
                        </Row>
                        { (this.state.addNotEditMode) ? <Row></Row>:
                        <Row ><div className='text'>
                            <p>Please Select Description to Edit</p>
                           {proposedDescrSelectList}
                            </div>
                        </Row> 
                        }
                        
                        { (this.state.addNotEditMode) ?
                        <Row>
                            <Col>
                            <div className='text'>
                                <p>Description to save</p>
                            </div>
                            </Col>

                            <Col>
                            <TextField className='propertyDescription-field'                                                      
                                id="propertyDescriptionTextField"                                
                                type="search"                               
                                margin="normal"
                                variant="outlined"                                
                                value={this.state.propertyDescription}                            
                                onChange={(e) => this.handleChangePropertyDescription(e)}                            
                            />                         
                            </Col>                            
                        </Row>
                        : <Row> </Row> }
                         { (this.state.addNotEditMode) ?
                        <Row>
                            <Button                            
                                className="update-button show"
                                variant="contained"
                                disabled={this.state.loadingProductTypes}
                                onClick={                                    
                                    this.saveAction
                                    }>Save
                            </Button>                           
                        </Row> 
                        :
                        (this.state.editChoicesAvailable) ? 
                        <Container>
                            <Row>
                                <Button                            
                                    className="update-button show"
                                    variant="contained"
                                    disabled={this.state.loadingProductTypes}
                                    onClick={ this.acceptAction }
                                    >Accept
                                </Button>                                           
                            </Row>
                            <Row>
                                <Button                            
                                    className="update-button show"
                                    variant="contained"
                                    disabled={this.state.loadingProductTypes}
                                    onClick={this.acceptRenameAction}
                                >Rename
                                </Button>      
                                <TextField className='renameDescription-field'                                                         
                                    id="renameDescriptionTextField"                                    
                                    margin="normal"
                                    variant="outlined"                                
                                    value={this.state.renameDescription}
                                    onChange={(e) => this.handleChangeRenameDescription(e)}                                
                                />  
                            </Row>
                           <Row>
                                <Button                            
                                    className="update-button show"
                                    variant="contained"
                                    disabled={this.state.loadingProductTypes}
                                    onClick={ this.reMapAction }
                                    >Map to Existing
                                </Button>                                
                                {goodDescrSelectList}                               
                            </Row>    
                        </Container>
                        :
                        <Row>  </Row>
                        }
                         { (this.state.addNotEditMode && false) ?
                         <Row> 
                             <Button                            
                                className="update-button show"
                                variant="contained"
                                disabled={this.state.loadingProductTypes}
                                onClick={ this.rejectAction}
                                    >Reject
                            </Button>  
                           
                            </Row>
                            :
                        <Row>  </Row>
                        }
                    </Col>
                </Row>
                
                { !(this.state.foundRecords) ? <Row> </Row> :
                <Row>
                    <div>
                    <ReactTable        
                        getTrProps={
                             (state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                                return {
                                    onClick: (e) => {
                                        console.log(rowInfo.index);
                                        if(rowInfo !== undefined &&
                                            rowInfo.index !== undefined && rowInfo.index >= 0)
                                        {
                                            //console.log(rowInfo);
                                            //console.log(rowInfo.row._original.informationDescription);
                                            //console.log(rowInfo.row._original.informationId);
                                            //console.log(rowInfo.row._original.informationType);                                            
                                            if( this.state.addNotEditMode !== false )
                                            {
                                                this.toggleModeAction();
                                            }
                                            //select proposed 
                                            this.setState( {
                                                selectedExistingRow:{
                                                informationId: rowInfo.row._original.informationId,
                                                informationType: rowInfo.row._original.informationType,
                                                informationDescription: rowInfo.row._original.informationDescription,
                                                obsolete: false,                
                                                shouldReview: false    
                                            }
                                            })
                                            let allowAppend = true;
                                            // choosing for now to allow several selected rows to be edit candidates.
                                            for (let index = 0; index < this.state.informationDescriptionDataSet.length; index++)
                                            {
                                                if( this.state.informationDescriptionDataSet[index].informationId === rowInfo.row._original.informationId)
                                                {
                                                    allowAppend = false;
                                                    break;
                                                }
                                            }
                                            if (allowAppend === true)
                                            {
                                                console.log("semidef appending");
                                                this.setState({                                                  
                                                    informationDescriptionDataSet:
                                                            this.state.informationDescriptionDataSet.concat(rowInfo.row._original)
                                                })                                              
                                            }  
                                            
                                            this.setState({ editChoicesAvailable : true});
                                        }
                                                                     
                                    }
                                }
                                }else{
                                return {}
                                }
                            }
                         }

                        data={this.state.informationDataSet}
                        columns={[
                            {  
                                  Header: "Description",
                                  accessor: "informationDescription",
                                  id: "informationDescription",
                                  sortMethod: (a, b) => {
                                      if ( !isNaN(a) && !isNaN(b) )
                                      {
                                          return parseInt(a) - parseInt(b);
                                      }                                   
                                      return a > b ? 1 : -1;                                   
                                  }
                            }
                        //,
                          //  {
                            //      Header: "Obsolete",   
                              //    id: "obsolete",                                                                 
                                //  accessor: d => d.obsolete,
//                                  width: 80
  //                          } 
                        ]}
                        defaultPageSize={  this.state.informationDataSet.length<=10? this.state.informationDataSet.length: 10}
                        //pivotBy={["shipmentAuthorizationNumber"]}                        
                        filterable
                        filtered={this.state.filtered}
                        onFilteredChange={filtered => this.setState({ filtered })}
                        sorted={this.state.sorted}
                        onSortedChange={sorted => this.setState({ sorted })}
                    />
                    </div>
               </Row>                         
            }                       
            </Container>
        )
    }

    handleChangePropertyDescription (event){
        this.setState({propertyDescription: event.target.value});
        console.log("pd = "+this.state.propertyDescription);            
    }
    handleChangeRenameDescription (event){
        this.setState({renameDescription: event.target.value});
        console.log("rn = "+this.state.renameDescription);            
    }
    
 
         
toggleModeAction()
{
    //console.log("togglemode action with addNotEditMode ="+this.state.addNotEditMode);
    //set logic is reversed sicne next line set addNotEdit = !addNotEdit
    this.setState({toggleModeButtonText: this.state.addNotEditMode ?'Change to Add Mode': 'Change to Edit Mode'});
   
    this.setState({addNotEditMode: !this.state.addNotEditMode});    
}


acceptRenameAction()
{
    if (this.state.editChoicesAvailable === false) // must be in Edit Mode
        return;
    if (this.state.selectedInformationDescription === undefined)
    {
        console.log("nothing selected to work on, selectedInformationDescription is undefined");
        return;
    }    
    if(this.state.selectedInformationDescription.informationId === undefined)
    {
        console.log("no .informationId selected to work on");
        return;
    }
    if(this.state.renameDescription === undefined || this.state.renameDescription.length === 0)
    {
        console.log("empty rename field");
        return;
    }
    
    // at this point this.state.selected_Menu_Name === this.state.selectedInformationDescription.informationType
    //console.log("rename this.state.selected_Menu_Name "+ this.state.selected_Menu_Name);
    //console.log("this.state.selectedInformationDescription.informationId" +this.state.selectedInformationDescription.informationId);
    //console.log ("this.state.selectedInformationDescription.informationType ="+this.state.selectedInformationDescription.informationType);

    const shouldReview = false;
    //updateInformation(infoId, informationType,description, shouldReview,productTypeId, productTypeName)
    this.returnsSrv.updateInformation(
        this.state.selectedInformationDescription.informationId,
        this.state.selectedInformationDescription.informationType,
        this.state.renameDescription,
        shouldReview,
        this.state.newProduct.productType.id,
        this.state.newProduct.productType.name
            
        ).then((res) => {
            console.log(res);
            if (res.ok){               
                //window.location.reload();
                this.setState({renameDescription: ""});
                this.getInformationList(this.state.newProduct.productType, this.state.selected_Menu_Name)
            }
        });
}
acceptAction(){
    console.log("Accept action!")
    // standard reject if not selected.
    if (this.state.editChoicesAvailable === false) // must be in Edit Mode
        return;
    if (this.state.selectedInformationDescription === undefined)
    {
        console.log("nothing selected to work on, selectedInformationDescription is undefined");
        return;
    }
    if(this.state.selectedInformationDescription.informationId === undefined)
    {
        console.log("no .informationId selected to work on");
        return;
    }
    this.setState({renameDescription: ""}); // clear rename action to sweep up.
    
        const shouldReview = false;
    this.returnsSrv.updateInformation(
        this.state.selectedInformationDescription.informationId,
        this.state.selectedInformationDescription.informationType,
        this.state.selectedInformationDescription.informationDescription,
        shouldReview,
        this.state.newProduct.productType.id,
        this.state.newProduct.productType.name
            
        ).then((res) => {
            if (res.ok){
                console.log(res);
                //window.location.reload();
                this.getInformationList(this.state.newProduct.productType, this.state.selected_Menu_Name)
            }
        });
}

reMapAction()
{
    // error check section 
    if (this.state.editChoicesAvailable === false) // must be in Edit Mode
        return;
    if (this.state.selectedInformationDescription === undefined)
    {
        console.log("nothing selected to work on, selectedInformationDescription is undefined");
        return;
    }    
    if(this.state.selectedInformationDescription.informationId === undefined)
    {
        console.log("no .informationId selected to work on");
        return;
    }
    if(this.state.selectedGoodInformationForRemap === undefined
        || this.state.selectedGoodInformationForRemap.informationId === undefined)
    {
        console.log("informationId targeted for remap");
        return;
    }
    
    // so the remap.
    console.log("remap from:");
    console.log(this.state.selectedInformationDescription);
    console.log("remap to:");
    console.log(this.state.selectedGoodInformationForRemap);
    this.returnsSrv.getReturnsByReturnInformationId(this.state.selectedInformationDescription.informationId)
    .then((res) => {
        
        if(res.status >= 200 && res.status <= 299){
            console.log("reMapAction got OK for fetch records to update **********");
            return res.json() 
        }else{
            console.log("reMapAction got error for fetch records to update !!!!!!!!!!!"+res.statusText);
            throw Error(res.statusText);
        }
    }
    )
    .then((result) => {
                
        if (result[0] && result.length > 0) {
            let myCount = 0
            
            let  promises = [];
            for (let index = 0; index < result.length; index++) {
                let element = result[index];
                if( index < 10 || index % 100 === 1)
                {
                    console.log(element);
                }                        

                const returnId =element.id;
                if( element.information === undefined)
                {
                    console.log("how on earth did we get here? "+returnId);
                    break;
                }
                               
                for (let infoIndex =0; infoIndex < element.information.length; infoIndex++){
                    if(element.information[infoIndex].id === this.state.selectedInformationDescription.informationId)
                    { // then we have found a match to update.
                        console.log("actually called new element mod");
                        element.information[infoIndex].id = this.state.selectedGoodInformationForRemap.informationId;
                        element.information[infoIndex].type = this.state.selectedGoodInformationForRemap.informationType;
                        element.information[infoIndex].description = this.state.selectedGoodInformationForRemap.informationDescription;
                        element.information[infoIndex].shouldReview = false;
                        console.log(element.information[infoIndex])
                        break;
                    }
                }
                myCount = myCount+1     
                console.log(".....calling return with element......");
                console.log(element);
              
                let p1 = this.returnsSrv.updateReturn(element).then((innerRes) => {
                    if (innerRes.ok){
                        console.log(innerRes);
                        return true;
                    }
                    else
                    {
                        console.log(innerRes);
                        console.log("NOT OK! " + returnId);
                        console.log(innerRes.statusText);                        
                        console.log(innerRes);
                        throw Error(innerRes.statusText);
                       // return false;
                    }
                });      
                promises.push(p1);                       
               
            } //end for  

            Promise.all(promises)
            .then( (ps) => {
                let allOK = true;
                ps.forEach(function (p) {
                    console.log("promise is value "+p);
                    if (p !== true)
                    {                        
                        allOK = false;
                        console.log("promise is value BAD. SETTING ALLOK FALSE ");
                    }
                }
                );
                console.log("allOK "+allOK);
                return allOK;                
            })
            .then( (del) =>
                {
                    if (del===true){
                        console.log("calling reject ");
                        this.rejectAction();   
                        this.setState({renameDescription:""});
                    }
                }
            )
            .catch(function (reason) {
                // Receives first rejection among the promises
            })              
            ;          
        } 
        else
        {
            console.log('sent but empty result');
            this.rejectAction(); 
            this.setState({renameDescription:""});
        }

    },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            
            console.error('error! '+ error);
            this.setState({
                loadingInformationList: false,
                shipment: [],
                error: error,
                foundRecords: false
            })  
            //this.setState({informationDataSet })   
            this.setState({userDisplay: 'Error fetching data.'})
                                 
        }
    ).catch(function (reason) { // this context is not passed into the function
        this.setState({
            loadingInformationList: false,
            shipment: [],
            error: reason,
            foundRecords: false
        })
    });
}

rejectAction(){
    console.log("Reject action!")
    // standard reject if not selected.
    if (this.state.editChoicesAvailable === false) // must be in Edit Mode
        return;
    if (this.state.selectedInformationDescription === undefined)
    {
        console.log("nothing selected to work on, selectedInformationDescription is undefined");
        return;
    }
    if(this.state.selectedInformationDescription.informationId === undefined)
    {
        console.log("no .informationId selected to work on");
        return;
    }       
     
    // this was true until we started allowing delete of existing items.
    //if(this.state.selectedInformationDescription.shouldReview === undefined
      //  || this.state.selectedInformationDescription.shouldReview !== true)
    //{
        //console.log("ONLY should review items can be deleted.");
      //  return;
    //}       

    this.returnsSrv.deleteInformation(this.state.selectedInformationDescription.informationId            
        ).then((res) => {
            if (res.ok){
                console.log(res);                
                this.getInformationList(this.state.newProduct.productType, this.state.selected_Menu_Name)
            }
        });
}

  saveAction() {
      console.log("save action!")
      console.log("save action with "+this.state.propertyDescription)
      if(this.state.propertyDescription.length === 0)
      {
        console.log("save action empty, returning");        
        return;
      }
      // check that Article type it not empty
      if(this.state.newProduct.productType === undefined
        || this.state.newProduct.productType.id === undefined
        || this.state.newProduct.productType.id.length === 0
        )
      {
        console.log("need to select an Article type first, returning");
        return;
      }
      console.log("Article type id= "+this.state.newProduct.productType.id);
      console.log("Article type name= "+this.state.newProduct.productType.name);
      if(this.state.selected_Menu_Name === undefined
        || this.state.selected_Menu_Name.length === 0 )
        {
            console.log("select a returnInformationType i.e. Menu");
            return;
        }
        console.log("this.state.selected_Menu_Name ="+this.state.selected_Menu_Name);
      
      
        this.returnsSrv.createReturnsInformation(
            this.state.propertyDescription, this.state.selected_Menu_Name,
            this.state.newProduct.productType.id, this.state.newProduct.productType.name
            ).then((res) => {
                if (res.ok){
                    console.log(res);
                    this.setState({propertyDescription: ""});
                    this.getInformationList(this.state.newProduct.productType, this.state.selected_Menu_Name)
                }
            });
      
  }// end save action

  getInformationList(ArticleTypeIn, menuNameIn)
  {
    //const dateFormat = 'YYYY-MM-DD';       
    this.setState({ // clear initial set, not append.
        informationDataSet: [],
        informationDescriptionDataSet: [],
        editChoicesAvailable: false,
        foundRecords : false
    })

    // entry validation
    if(menuNameIn === undefined || menuNameIn === 0)
    {
      console.log("selected_Menu_Name empty, returning");        
      return;
    }
    // check that Article type it not empty
    if(ArticleTypeIn === undefined
      || ArticleTypeIn.id === undefined
      || ArticleTypeIn.id.length === 0
      )
    {
      console.log("need to select an Article type first, returning");
      return;
    }
    console.log("getInformationList Article type id= "+ArticleTypeIn.id);
    console.log("getInformationList Article type name= "+ArticleTypeIn.name);    
    console.log("getInformationList menuNameIn ="+menuNameIn);
    const infoType=menuNameIn;
    const ArticleTypeId= ArticleTypeIn.id;

    console.log("getInformationList called with "+infoType);
    console.log("getInformationList called with "+ArticleTypeId);
    console.log("getInformationList and         "+ArticleTypeIn.name);

    //var dispCountloading = 'Loading...'
    //this.setState({userDisplay: dispCountloading})  
    this.setState({ loadingInformationList: true }, () => {
        this.returnsSrv.getAllInformation(infoType, ArticleTypeId)        
            .then((res) => {
                this.setState({ isProductTypesLoaded: true });
                if(res.status >= 200 && res.status <= 299){
                    console.log("got something for info **********");
                    return res.json() 
                }else{
                    console.log("got error for info !!!!!!!!!!!"+res.statusText);
                    throw Error(res.statusText);
                }
            }
            )
            .then((result) => {
                                 
                this.setState({ // clear initial set, not append.
                    informationDataSet: [],
                    informationDescriptionDataSet: [],
                    editChoicesAvailable: false
                })
                
                if (result[0] && result.length > 0) {
                    let myCount = 0
                    var accumulated = [];
                    var proposedAccumulated = [];
                    for (let index = 0; index < result.length; index++) {
                        const element = result[index];
                        if( index < 10 || index % 100 === 1)
                        {
                            console.log(element);
                        }                        
                        const informationId =element.id;
                        const informationType = element.type;
                        const informationDescription= element.description;    
                        const isshouldReview = element.shouldReview === undefined ? false : element.shouldReview;
                        var fetchedLine = {
                            informationId: informationId,
                            informationType:  informationType,
                            informationDescription: informationDescription,
                            obsolete: false     ,  
                            shouldReview: isshouldReview                     
                        }                                     
                        myCount = myCount + 1     
                        if(isshouldReview === true)
                        {
                            proposedAccumulated = proposedAccumulated.concat(fetchedLine);
                        }
                        else
                        {
                            accumulated = accumulated.concat(fetchedLine);
                        }
                    } //end for    

                    // Default sort results; should have no need of 2nd level sort. That is a data entry error.
                    accumulated.sort((a, b) =>
                     (a.informationDescription > b.informationDescription) ?
                         1 : (a.informationDescription === b.informationDescription) ?
                                 ((a.informationId > b.informationId) ? 1 : -1) : -1 )

                    this.setState({
                        informationDataSet: accumulated,
                        informationDescriptionDataSet: proposedAccumulated
                    })
                    var dispCount = myCount+' Records Found'                         

                    this.setState({foundRecords: (myCount !== 0) })
                    this.setState({loadingInformationList: false})
                    console.log(this.state.foundRecords+' records found');                        
                    console.log(dispCount);   
                   
                    this.setState({
                        editChoicesAvailable: proposedAccumulated.length > 0
                    })
                   
                } 
                else
                {
                    console.log('sent but no result');
                    var dispCount0 = '0 Records Found'                         
                    this.setState({userDisplay: dispCount0})                        
                    this.setState({foundRecords: false})
                    this.setState({loadingInformationList: false})
                   // this.setState({informationDataSet: []      })
                }

            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    
                    console.error('error! '+ error);
                    this.setState({
                        loadingInformationList: false,
                        shipment: [],
                        error: error,
                        foundRecords: false
                    })  
                    //this.setState({informationDataSet })   
                    this.setState({userDisplay: 'Error fetching data.'})
                                         
                }
            ).catch(function (reason) { // this context is not passed into the function
                this.setState({
                    loadingInformationList: false,
                    shipment: [],
                    error: reason,
                    foundRecords: false
                })
            });
    })
  }   

 
} // end class

    ManageListsForm.propTypes = {
        auth: PropTypes.object
    };

export default ManageListsForm;